import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Logo from "@/components/Logo";
import { track } from "@/lib/track";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("order_id");
  useEffect(() => { track("payment_cancel"); }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background px-6" data-testid="payment-cancel-page">
      <Logo />
      <div className="flex flex-col items-center gap-3 text-center">
        <XCircle className="h-14 w-14 text-destructive" />
        <h1 className="font-heading text-2xl font-extrabold text-kilted-green">Payment cancelled</h1>
        <p className="max-w-sm text-sm text-muted-foreground">No charge was made. Your booking is saved and still awaiting payment — you can complete it any time.</p>
        <div className="mt-2 flex gap-3">
          {orderId && (
            <Button onClick={() => navigate(`/orders/${orderId}`)} data-testid="retry-payment-button" className="bg-kilted-green hover:bg-kilted-greenLight">Complete payment</Button>
          )}
          <Button variant="outline" onClick={() => navigate("/dashboard")} data-testid="cancel-dashboard-button">Back to deliveries</Button>
        </div>
      </div>
    </div>
  );
}
